import React from 'react';
import { getColor } from './chartHelper';
var AreaGradient = function AreaGradient(_ref) {
  var id = _ref.id,
    color = _ref.color;
  return /*#__PURE__*/React.createElement("linearGradient", {
    key: id,
    id: id,
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: getColor(color),
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: getColor(color),
    stopOpacity: 0
  }));
};
AreaGradient.defaultProps = {
  id: 'areaGradient',
  color: 'color-coldplay-fountain'
};
export default AreaGradient;